module.exports = __webpack_public_path__ + "static/img/pic_coop05@2x.0f37906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/pic_coop05@2x.png
// module id = gbs5
// module chunks = 0